export default __webpack_public_path__ + "static/media/cloud5.4b05cb0c.svg";